<script setup>
defineProps({
  language: String,
  t: Function,
  paragraphs: Array
});
const emit = defineEmits(['agree', 'decline']);
</script>

<template>
  <section class="license-screen vue-license-screen" aria-hidden="false">
    <div class="license-composition">
      <article class="agreement-panel" :aria-label="t('agreement.title', '会员协议')">
        <header class="vue-agreement-heading">
          <span>{{ t('agreement.title', 'Member Agreement') }}</span>
          <h1>{{ t('agreement.title', '会员协议') }}</h1>
          <i aria-hidden="true" />
        </header>
        <div class="agreement-scroll" tabindex="0">
          <p
            v-for="(paragraph, index) in paragraphs"
            :key="`${language}-${index}`"
            :class="{ 'notice-title': index === 9, 'final-line': index === paragraphs.length - 1 }"
          >{{ paragraph }}</p>
        </div>
      </article>
      <aside class="agreement-side">
        <img class="agreement-logo" src="/assets/brand/wanli-script-gold-v1.webp" alt="Wanli" />
        <div class="agreement-rule" />
        <div class="vue-license-copy">
          <span>{{ t('vueDesktop.login.memberAccess', 'Member Access') }}</span>
          <b>{{ t('agreement.title', '会员协议') }}</b>
          <p>{{ t('vueDesktop.agreement.reviewTerms', 'Review and accept the member terms to enter the VIP lobby.') }}</p>
        </div>
        <div class="vue-license-ornament" aria-hidden="true"><i /><span>WANLI</span><i /></div>
        <div class="agreement-actions">
          <button class="agreement-button agree-action" type="button" @click="emit('agree')">{{ t('button.agree', '同意') }}</button>
          <button class="agreement-button secondary disagree-action" type="button" @click="emit('decline')">{{ t('button.disagree', '不同意') }}</button>
        </div>
      </aside>
    </div>
  </section>
</template>
